<template>
    <div class="scroll-image-container" ref="imgsccc">
        <div
            class="scroll-image-wrapper"
            :style="{ transform: `translateX(${scrollX}px)` }"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
        >
            <div
                v-for="(image, index) in cases"
                :key="index"
                style="margin-right: 20px"
                @load="imageLoaded"
                ref="imgdiv"
            >
                <img :src="image.img" />
                <div class="imgBom">
                    <h2 class="title">{{ image.title }}</h2>
                    <p class="con">{{ image.content }}</p>
                </div>
            </div>
        </div>
        <div class="custom-scrollbar">
            <div
                class="scrollbar-thumb"
                :style="{
                    width: scrollbarWidth + 'px',
                    left: scrollbarLeft + 'px',
                }"
            ></div>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="88%"
            :before-close="handleClose"
        >
            <button class="nav-button prev-button" @click="par()">&lt;</button>
            <button class="nav-button next-button" @click="next()">&gt;</button>
            <div style="height: 50%; width: 95%" class="imgBox">
                <img :src="ImgUrl" alt="" style="height: 100%; width: 100%" />
            </div>
            <div style="height: 50%; width: 95%">
                <h3 style="margin: 0 0 5px 0; text-align: center">案例简介</h3>
                <div v-html="processedString" style="line-height: 1.4"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [
                require("@/assets/tecImg/图片1.png"),
                require("@/assets/tecImg/图片2.png"),
                require("@/assets/tecImg/图片3.png"),
                require("@/assets/tecImg/图片4.png"),
            ],
            cases: [
                {
                    img: require("@/assets/tecImg/图片5.png"),
                    title: "安全疏散仿真系统",
                    content: "客户单位：清华大学",
                },
                {
                    img: require("@/assets/tecImg/图片6.png"),
                    title: "Evotl系统",
                    content: "客户单位：小鹏汇天",
                },
                {
                    img: require("@/assets/tecImg/图片7.png"),
                    title: "无人机指挥控制模拟训练系统",
                    content: "客户单位：成都航空职业技术学院",
                },
                {
                    img: require("@/assets/tecImg/图片8.png"),
                    title: "人在环综合仿真验证系统",
                    content: "客户单位：商飞北研",
                },
            ],
            scrollX: 0,
            touchStartX: 0,
            initialScrollX: 0,
            animationFrameId: null,
            scrollbarWidth: 0,
            scrollbarLeft: 0,
            loadedImagesCount: 0,
            clickThreshold: 10,
            isClick: false,
            dialogVisible: false,
            IndexNum: 0,
            clickNum: 0,
            ImgUrl: require("../assets/yone0/图片0.png"),
            tableText: [
                {
                    name: "清华大学",
                    value: "1、支持生理数据采集设备的集成（肌电、脑电、近红外和眼动设备）；2、多平台支持（双视点CAVE、VR和PC）；3、快速的疏散场景制作；4、支持多端设备的协同仿真；5、支持疏散算法的集成和定制；6、支持FDS数据解析和渲染；7、支持人员轨迹、密度、速度、热力图显示；8、支持跑步机、光学动捕和惯性动捕设备。",
                },
                {
                    name: "小鹏汇天",
                    value: "1、真实大范围地形、卫星影像与地形贴图无缝混合实现；2、可模拟雨、雪和雾天气效果；3、基于GIS数据的城市建筑和道路自动生成，动态加载显示；4、典型地标建筑采用人工精细化建模；5、支持多通道投影融合和矫正（270度柱幕）；6、UDP仿真数据驱动。",
                },
                {
                    name: "成都航空职业技术学院",
                    value: "1、支持飞行控制训练、任务规划训练、任务载荷训练和链路监控训练；2、支持三维大地图的定制；3、飞行训练支持滑行、爬升、定高平飞、五边飞行和自由飞行科目；4、任务载荷支持武器规划、光电吊舱规划、SAR雷达规划和载荷控制；5、任务规划支持二维地图显示、航路点规划和起降航线规划；6、基于web技术，可通过浏览器访问使用。",
                },
                {
                    name: "商飞北研",
                    value: "1、全球大场景地形、卫星影像与地形贴图无缝混合现实；2、飞行器自动化构建，机场程序化构建，JSBSIM飞行仿真模块集成；3、多人在线仿真框架，支持多单位、部门的协同；4、支持人在环的人机工效评估。",
                },
            ],
        };
    },
    watch: {
        IndexNum() {
            this.ImgUrl = require(`../assets/yone${this.IndexNum}/图片${this.clickNum}.png`);
        },
        clickNum() {},
        dialogVisible() {
            if (!this.dialogVisible) {
                this.clickNum = 0;
                this.IndexNum = 0;
            } else {
                if (this.IndexNum == 0) {
                    this.ImgUrl = require(`../assets/yone0/图片0.png`);
                }
            }
        },
    },
    computed: {
        processedString() {
            const items = this.tableText[this.IndexNum].value.split("；");
            // 去除最后一个可能为空的元素
            if (items[items.length - 1] === "") {
                items.pop();
            }
            // 为每个元素添加换行标签
            return items.map((item) => `${item}<br>`).join("");
        },
    },
    methods: {
        par() {
            if (this.clickNum > 0) {
                this.clickNum--;
            }

            this.ImgUrl = require(`../assets/yone${this.IndexNum}/图片${this.clickNum}.png`);
        },
        next() {
            switch (this.IndexNum) {
                case 0:
                    if (this.clickNum < 9) {
                        this.clickNum++;
                    }
                    break;
                case 1:
                    if (this.clickNum < 5) {
                        this.clickNum++;
                    }
                    break;
                case 2:
                    if (this.clickNum < 3) {
                        this.clickNum++;
                    }
                    break;
                case 3:
                    if (this.clickNum < 5) {
                        this.clickNum++;
                    }
                    break;

                default:
                    break;
            }

            this.ImgUrl = require(`../assets/yone${this.IndexNum}/图片${this.clickNum}.png`);
        },
        handleClose(done) {
            done();
        },
        open(index) {
            if (this.isClick) {
                const clickedImage = this.cases[index];
                // console.log(index);
                this.IndexNum = index;
                this.dialogVisible = true;
            }
        },
        handleTouchStart(event) {
            event.preventDefault();
            event.stopPropagation();
            this.touchStartX = event.touches[0].clientX;
            this.initialScrollX = this.scrollX;
            const wrapper = this.$el.querySelector(".scroll-image-wrapper");
            wrapper.style.willChange = "transform";
            this.isClick = true;
        },
        handleTouchMove(event) {
            event.preventDefault();
            event.stopPropagation();
            const currentX = event.touches[0].clientX;
            const deltaX = Math.abs(currentX - this.touchStartX);
            if (deltaX > this.clickThreshold) {
                this.isClick = false;
            }
            const newScrollX =
                this.initialScrollX + (currentX - this.touchStartX);

            let b = window.innerWidth * 0.1;
            let a = this.$refs.imgdiv;
            let sum = 0;
            for (let i = 0; i < a.length; i++) {
                sum += a[i].offsetWidth - 60;
            }

            const maxScroll = -(sum - b);

            // const maxScroll = -970;
            const finalScrollX = Math.max(Math.min(newScrollX, 0), maxScroll);

            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
            }
            this.animationFrameId = requestAnimationFrame(() => {
                this.scrollX = finalScrollX;
                this.updateScrollbar();
            });
        },
        handleTouchEnd(event) {
            const wrapper = this.$el.querySelector(".scroll-image-wrapper");
            wrapper.style.willChange = "auto";
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
            }
            this.updateScrollbar();

            if (this.isClick) {
                const target = event.changedTouches[0].target;
                const imageDiv = target.closest(".scroll-image-wrapper > div");
                if (imageDiv) {
                    const index = Array.from(
                        imageDiv.parentNode.children
                    ).indexOf(imageDiv);
                    this.open(index);
                }
            }
            this.isClick = false;
        },
        updateScrollbar() {
            const scrollContainer = this.$refs.imgsccc;
            if (scrollContainer) {
                const trackWidth = scrollContainer.offsetWidth;

                let b = window.innerWidth * 0.1;
                let a = this.$refs.imgdiv;
                let sum = 0;
                for (let i = 0; i < a.length; i++) {
                    sum += a[i].offsetWidth - 60;
                }

                const imageScrollRange = sum - b;
                // const imageScrollRange = 970;
                const imageScrollPosition = -this.scrollX;

                const { scrollbarWidth, scrollbarPosition } =
                    this.calculateScrollbarPosition(
                        imageScrollPosition,
                        imageScrollRange,
                        trackWidth
                    );

                this.scrollbarWidth = scrollbarWidth;
                this.scrollbarLeft = scrollbarPosition;
            }
        },
        calculateScrollbarPosition(
            imageScrollPosition,
            imageScrollRange,
            trackWidth
        ) {
            const scrollbarWidth = trackWidth / 4;
            const scrollbarMaxMove = trackWidth - scrollbarWidth;
            const scrollbarPosition =
                (imageScrollPosition / imageScrollRange) * scrollbarMaxMove;

            return {
                scrollbarWidth,
                scrollbarPosition,
            };
        },
        imageLoaded() {
            this.loadedImagesCount++;
            if (this.loadedImagesCount === this.images.length) {
                this.$nextTick(() => {
                    this.updateScrollbar();
                });
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.updateScrollbar();
        });
    },
    beforeDestroy() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
    },
};
</script>

<style scoped>
.scroll-image-container {
    width: 100%;
    height: 34%;
    overflow: hidden;
    position: relative;
}

.scroll-image-wrapper {
    display: flex;
    transition: transform 0.1s ease-out;
    will-change: transform;
    width: auto;
    height: 90%;
}

.scroll-image-wrapper img {
    min-width: 300px;
    height: 200px;
    /* width: 320px; */
    max-width: 320px;
    /* margin-right: 20px; */
}

.custom-scrollbar {
    position: relative;
    height: 4px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 2px;
    /* bottom: 0; */
}

.scrollbar-thumb {
    position: absolute;
    height: 100%;
    background-color: rgba(11, 124, 181);
    border-radius: 2px;
    transition: left 0.1s ease-out;
}
.imgBom {
    height: 35%;
    width: 100%;
    background-color: #fff;
}
.title {
    margin-top: 0;
    font-size: 20px;
}
.con {
    font-size: 18px;
}
::v-deep .el-dialog__body {
    height: 60vh;
}
.nav-button {
    position: absolute;
    top: 27%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    height: 40px;
    width: 40px;
    border: none;
    border-radius: 20px;
    font-size: 20px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    transition: opacity 0.3s ease;
    z-index: 10;
}

/* 上一页按钮位置样式 */
.prev-button {
    left: 10px;
}

/* 下一页按钮位置样式 */
.next-button {
    right: 10px;
}
</style>